__turbopack_context__.v({
  "checkboxLabel": "d-hd_W_checkboxLabel",
  "checkmark": "d-hd_W_checkmark",
  "closeButton": "d-hd_W_closeButton",
  "createLabelButton": "d-hd_W_createLabelButton",
  "editButton": "d-hd_W_editButton",
  "headerActions": "d-hd_W_headerActions",
  "leftSide": "d-hd_W_leftSide",
  "loadMoreButton": "d-hd_W_loadMoreButton",
  "loadMoreContainer": "d-hd_W_loadMoreContainer",
  "minimizeButton": "d-hd_W_minimizeButton",
  "modalContainer": "d-hd_W_modalContainer",
  "modalHeader": "d-hd_W_modalHeader",
  "modalOverlay": "d-hd_W_modalOverlay",
  "modalTitle": "d-hd_W_modalTitle",
  "searchContainer": "d-hd_W_searchContainer",
  "searchIcon": "d-hd_W_searchIcon",
  "searchInput": "d-hd_W_searchInput",
  "searchSection": "d-hd_W_searchSection",
  "tagCheckbox": "d-hd_W_tagCheckbox",
  "tagItem": "d-hd_W_tagItem",
  "tagsGrid": "d-hd_W_tagsGrid",
});
